<template>
    <div>
        <div v-if="deadlines.length">
            <span
                v-for="deadline in localDeadlines"
                :key="'deadline' + deadline.id"
            >
                <b-link
                    v-if="show(deadline)"
                    :title="title(deadline)"
                    @click="handleClick(deadline)"
                    @contextmenu="handleRightClick($event, deadline)"
                >
                    <span
                        :key="'toggle' + deadline.id"
                        class="badge mr-1 finger"
                        :class="deadline.class"
                    >
                        {{ deadline.day }}
                    </span>

                </b-link>
            </span>
        </div>

        <div v-else>
            <span>-</span>
        </div>

        <b-modal
            v-for="deadline in localDeadlines"
            :id="'deadline-modal-id' + deadline.id"
            :key="'deadline-modal-key' + deadline.id"
            title="Modification de l'échéance"
            hide-footer
            size="sm"
        >
            <p class="mb-2 font-weight-bold">{{ deadline.client_name }}</p>
            <p class="mb-2">{{ deadline.title }}</p>
            <deadline-date-form
                :deadline="deadline"
                @date-has-changed="closeDeadlineModal(deadline)"
            />
        </b-modal>

        <b-modal
            v-for="deadline in localDeadlines"
            :id="'todo-modal-id' + deadline.id"
            :key="'todo-modal-key' + deadline.id"
            title="To do"
            hide-footer
        >
            <todo-form :deadline="deadline"/>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import badgeDate from './badgeDate'
import DeadlineDateForm from './DeadlineDateForm'
import TodoForm from './TodoForm'

export default {
    name: 'DeadlinesHandler',

    components: {
        TodoForm,
        badgeDate,
        DeadlineDateForm,
    },

    props: ['deadlines'],

    data() {
        return {
            localDeadlines: [],
        }
    },

    created() {
        this.localDeadlines = this.deadlines
    },

    methods: {
        handleRightClick(e, deadline) {
            if (deadline.is_editable && !deadline.disabled) {
                this.$bvModal.show(`deadline-modal-id${deadline.id}`)
                e.preventDefault()
            }
        },

        closeDeadlineModal(deadline) {
            this.$bvModal.hide(`deadline-modal-id${deadline.id}`)
            this.$emit('update-table')
        },

        handleClick(deadline) {
            if (!deadline.disabled) {
                if (deadline.jdc_link === null) {
                    if (
                        deadline.achievement_date === null &&
                        deadline.show_time_sheet
                    ) {
                        this.$store.commit('data/RESET_MODAL_DATA')
                        const modalData = {
                            client: {
                                id: deadline.client_id,
                                name: deadline.client_name,
                                end_of_exercise:
                                deadline.client_end_of_exercise,
                            },
                        }
                        this.$store.commit('data/SET_MODAL_DATA', modalData)
                        this.$bvModal.show('modal-time-sheet')
                    } else {
                        // console.log('no timeSheet', deadline)
                    }
                    this.toggle(deadline.id)
                } else {
                    window.open(deadline.jdc_link)
                }
            }
        },

        async toggle(id) {
            try {
                const response = await axios.put(
                    `/clientDeadlines/${id}/toggle`
                )
                this.localDeadlines = response.data.data
                console.log('response: ', response.data.data)
                this.handleTodoModal(response.data.data, id)
                await this.$store.dispatch('reportingVM/getCounter', 'all')
                await this.$store.dispatch('reportingVM/getCounter', 'otherTax')
                await this.$store.dispatch(
                    'reportingVM/getCounter',
                    this.activePage
                )
            } catch (error) {
                // handle error
                console.log(error)
            }
        },

        handleTodoModal(data, id) {
            const deadline = data.find((item) => item.id === id)
            if (deadline.generate_todo === 1) {
                this.$bvModal.show(`todo-modal-id${id}`)
            }
        },

        show(deadline) {
            if (this.activePage === 'iss') {
                if (this.issFilter === 'advance') {
                    return deadline.nth < 5
                }
                if (this.issFilter === 'balance') {
                    return deadline.nth === 5
                }
                return true
            }
            // if (this.activePage === 'bil') {
            //     if (this.balanceStepFilter === 0) {
            //         return true
            //     }
            //     if (this.balanceStepFilter === 99) {
            //         return deadline.title.includes('DAS2')
            //     }
            //     if (this.balanceStepFilter > 0 && this.balanceStepFilter < 99) {
            //         return deadline.nth === this.balanceStepFilter && !deadline.title.includes('DAS2')
            //     }
            // }
            return true
        },

        title(deadline) {
            switch (deadline.status) {
                case 'achieved':
                    return `${deadline.title} | ${deadline.achieved_by} le ${deadline.achievement_date}`
                case 'disabled':
                    return `${deadline.title} | Annulé par ${deadline.disabled_by} le ${deadline.disabled_at}`
                default:
                    return `${deadline.title} | Budget : ${deadline.duration} h`
            }
        },

        jdcStatusIcon(status) {
            return status === 'ACC'
                ? 'far fa-fw fa-check text-success'
                : 'far fa-fw fa-times text-danger'
        },
    },

    computed: {
        ...mapState({
            activePage: (state) => state.browsing.pageName,
            issFilter: (state) => state.browsing.issFilter,
            balanceStepFilter: (state) => state.browsing.balanceStepFilter,
        }),
    },
}
</script>

<style scoped>
.finger {
    cursor: pointer;
}
</style>
